import './index-metric-get.style.scss'

class indexMetricGetController {

}

export default indexMetricGetController;



// WEBPACK FOOTER //
// ./ui/src/components/index-metric-get/index-metric-get.controller.js